// extracted by mini-css-extract-plugin
module.exports = {"chatHeader":"ticketDetail_chatHeader__1BW8q","chatBody":"ticketDetail_chatBody__1Eo3E","chatFooter":"ticketDetail_chatFooter__3Oh5j"};